import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

// Définition des palettes de couleurs
const colorThemes = {
  emerald: {
    name: 'Émeraude',
    primary: {
      50: '#ecfdf5',
      100: '#d1fae5',
      200: '#a7f3d0',
      300: '#6ee7b7',
      400: '#34d399',
      500: '#10b981',
      600: '#059669',
      700: '#047857',
      800: '#065f46',
      900: '#064e3b',
    },
    secondary: {
      500: '#065f46', // Même famille que emerald pour la cohérence
    }
  },
  ral6039: {
    name: 'Vert clair',
    // RAL 6039 = RGB(179, 196, 62) = #B3C43E
    primary: {
      50: '#f9fce8',
      100: '#f3f8d1',
      200: '#e7f1a3',
      300: '#d5e56a',
      400: '#c4d94e',
      500: '#B3C43E',
      600: '#B3C43E',
      700: '#B3C43E',
      800: '#B3C43E',
      900: '#B3C43E',
    },
    secondary: {
      500: '#4F5358', // RGB(79, 83, 88) - Gris foncé
    }
  }
};

export const ThemeProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState(() => {
    // Récupérer le thème sauvegardé ou utiliser ral6039 (Vert clair) par défaut
    const saved = localStorage.getItem('fv-color-theme');
    return saved || 'ral6039';
  });

  useEffect(() => {
    // Sauvegarder le thème dans localStorage
    localStorage.setItem('fv-color-theme', currentTheme);
    
    // Appliquer les variables CSS
    const theme = colorThemes[currentTheme];
    const root = document.documentElement;
    
    Object.entries(theme.primary).forEach(([shade, color]) => {
      root.style.setProperty(`--color-primary-${shade}`, color);
    });
    
    // Appliquer la couleur secondaire
    if (theme.secondary) {
      Object.entries(theme.secondary).forEach(([shade, color]) => {
        root.style.setProperty(`--color-secondary-${shade}`, color);
      });
    }
    
    // Ajouter une classe au body pour le thème
    document.body.setAttribute('data-theme', currentTheme);
  }, [currentTheme]);

  const toggleTheme = () => {
    setCurrentTheme(prev => prev === 'emerald' ? 'ral6039' : 'emerald');
  };

  return (
    <ThemeContext.Provider value={{ 
      currentTheme, 
      setCurrentTheme, 
      toggleTheme,
      themes: colorThemes,
      themeName: colorThemes[currentTheme].name
    }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export default ThemeContext;
